import { Link } from 'react-router-dom';
import { LegalChrome } from './LegalChrome';

const LAST_UPDATED = 'June 22, 2026';

export function CommunityGuidelinesPage() {
  return (
    <LegalChrome>
      <h1 className="legal-h1">Community Guidelines</h1>
      <p className="legal-muted">Last updated: {LAST_UPDATED}</p>

      <p className="legal-p">
        Kynward is built for respectful, low-pressure conversation in guided groups. These
        guidelines apply to Circles, Signal Fire, mutual chats, and any other in-app interaction.
      </p>

      <h2 className="legal-h2">Be respectful</h2>
      <p className="legal-p">
        Treat others like real people. No harassment, hate, threats, bullying, or repeated unwanted
        contact. Disagree without attacking.
      </p>

      <h2 className="legal-h2">Keep it appropriate</h2>
      <p className="legal-p">
        Do not share illegal content, sexual content involving minors, non-consensual imagery, or
        content that promotes violence or exploitation. Kynward is for adults 18 and older only.
      </p>

      <h2 className="legal-h2">No spam or manipulation</h2>
      <p className="legal-p">
        Do not use Kynward for scams, spam, impersonation, or to push people off-platform for
        harmful purposes. Do not scrape, automate, or misuse the service.
      </p>

      <h2 className="legal-h2">Mutual and low-pressure</h2>
      <p className="legal-p">
        Private chats open through mutual keeps — not cold opens. Do not pressure others to share
        contact information, meet in person before you are both comfortable, or stay in a
        conversation that does not feel right.
      </p>

      <h2 className="legal-h2">Report and block</h2>
      <p className="legal-p">
        If something feels off, use in-app report and block tools. We review reports and may remove
        content, restrict accounts, or take other action consistent with our policies and applicable
        law.
      </p>

      <h2 className="legal-h2">Enforcement</h2>
      <p className="legal-p">
        Violations may result in a warning, feature restriction, temporary suspension, or permanent
        account removal. For severe violations — including child safety issues, threats, sexual
        exploitation, or illegal activity — we may skip earlier steps and take immediate action,
        including reporting to authorities where required.
      </p>

      <h2 className="legal-h2">Appeals</h2>
      <p className="legal-p">
        If you believe your account was restricted in error, contact{' '}
        <a className="legal-a" href="mailto:support@kynward.com">
          support@kynward.com
        </a>{' '}
        from the email address on your account. We review appeals where appropriate but are not
        obligated to restore access.
      </p>

      <h2 className="legal-h2">Related policies</h2>
      <p className="legal-p">
        These guidelines work alongside our{' '}
        <Link className="legal-a" to="/legal/terms-of-service">
          Terms of Service
        </Link>
        ,{' '}
        <Link className="legal-a" to="/legal/privacy-policy">
          Privacy Policy
        </Link>
        ,{' '}
        <Link className="legal-a" to="/legal/safety-policy">
          Safety Policy
        </Link>
        , and{' '}
        <Link className="legal-a" to="/child-safety">
          Child Safety Standards
        </Link>
        .
      </p>
    </LegalChrome>
  );
}
